import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Typography } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import SignInComponent from "../../components/auth/SignIn";

const customBlue = "#4782da";
const sidebarBg = "#233044";
const rightBg = "#2A3949";

const SignInRoot = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  background: ${rightBg};

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const LeftPanel = styled.div`
  position: relative;
  flex: 1;
  min-width: 360px;
  max-width: 440px;
  background: ${sidebarBg};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 40px;

  @media (max-width: 960px) {
    min-width: 100%;
    max-width: 100%;
    padding: 40px 24px;
    min-height: 240px;
  }
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Brand = styled(Logo)`
  width: 180px;
  height: auto;
  fill: ${customBlue};
  margin-bottom: 40px;
`;

const RightPanel = styled.div`
  flex: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: ${rightBg};

  @media (max-width: 960px) {
    padding: 40px 24px;
    min-height: calc(100vh - 240px);
  }
`;

const FormZone = styled.div`
  width: 100%;
  max-width: 400px;
`;

const FooterText = styled(Typography)`
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
`;

function SignIn() {
  return (
    <SignInRoot>
      <Helmet title="Connexion" />

      <LeftPanel>
        <LeftContent>
          <Brand />
          <Typography
            variant="h5"
            sx={{
              color: "rgba(255, 255, 255, 0.95)",
              fontWeight: 600,
              lineHeight: 1.3,
              mb: 2,
            }}
          >
            Bienvenue sur YLinar
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.65)",
              lineHeight: 1.6,
            }}
          >
            Connectez-vous pour accéder à votre espace de travail ERP et gérer votre activité.
          </Typography>
        </LeftContent>
        <FooterText>YLinar ERP © {new Date().getFullYear()}</FooterText>
      </LeftPanel>

      <RightPanel>
        <FormZone>
          <Typography
            component="h1"
            variant="h4"
            align="center"
            sx={{
              fontWeight: 600,
              color: "rgba(255, 255, 255, 0.95)",
              mb: 1,
            }}
          >
            Connexion
          </Typography>
          <Typography
            component="p"
            variant="body1"
            align="center"
            sx={{
              color: "rgba(255, 255, 255, 0.55)",
              mb: 4,
            }}
          >
            Connectez-vous pour continuer
          </Typography>

          <SignInComponent dark />
        </FormZone>
      </RightPanel>
    </SignInRoot>
  );
}

export default SignIn;
